// extracted by mini-css-extract-plugin
module.exports = {"logo":"routes_logo__3n8_v"};